import { useEffect, useState } from 'react'
import { File } from 'lucide-react'
import { materialsApi } from '@/api/materials'
import type { Material } from '@/types/material'

interface MaterialThumbnailProps {
	material: Material
	className: string
}

export function MaterialThumbnail({ material, className }: MaterialThumbnailProps) {
	const [src, setSrc] = useState('')
	const isImage = material.mime.startsWith('image/')

	useEffect(() => {
		if (!isImage) return
		let objectUrl = ''
		let active = true
		materialsApi.thumbnail(material.id)
			.then((url) => {
				objectUrl = url
				if (active) setSrc(url)
				else URL.revokeObjectURL(url)
			})
			.catch(() => {
				if (active) setSrc('')
			})
		return () => {
			active = false
			if (objectUrl) URL.revokeObjectURL?.(objectUrl)
		}
	}, [isImage, material.id])

	if (isImage) {
		return src ? (
			<img src={src} alt={`${material.original_name} 缩略图`} className={className} />
		) : (
			<div className="flex h-full w-full items-center justify-center rounded-md bg-muted text-xs text-muted-foreground">
				加载中
			</div>
		)
	}

	return (
		<div className="flex h-full w-full flex-col items-center justify-center gap-2 rounded-md bg-muted text-muted-foreground">
			<File className="h-7 w-7" />
			<span className="max-w-full truncate px-2 text-xs uppercase">{material.ext || 'FILE'}</span>
		</div>
	)
}
